export const querySizeMappings = {
	sm: 40,
	md: 48,
	lg: 64,
	xl: 90,
	"2xl": 120,
} satisfies Record<string, number>;
